import { Dropdown } from 'primereact/dropdown'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import khoaThiProcessor from '../../processor/khoaThiProcessor'
import namProcessor from '../../processor/namProcessor'
import { setKhoaThiId, setKhoaThis } from '../../store/reducer/khoaThi'
import { setNamId, setNams } from '../../store/reducer/nam'
import store from '../../store/store'

const ComboDropdownKhoaThi = (props) => {
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const listKhoaThi = useSelector((item) => item.khoaThi.datas)
  const namId = useSelector((item) => item.nam.id)
  const listNam = useSelector((item) => item.nam.datas)
  const getNam = async () => {
    if (props.getNam) {
      await props.getNam()
      return
    }
    const rs = await namProcessor.getAll()
    store.dispatch(setNams(rs))
    if (rs.length > 0) {
      store.dispatch(setNamId(rs[0].id))
    }
  }
  const getKhoaThi = async () => {
    if (props.getKhoaThi) {
      await props.getKhoaThi(namId)
      return
    }
    if (namId) {
      const rs = await khoaThiProcessor.getByNam(namId)
      if (rs.length > 0) {
        store.dispatch(setKhoaThiId(rs[0].id))
      }
      store.dispatch(setKhoaThis(rs))
    }
  }

  useEffect(getNam, [])
  useEffect(getKhoaThi, [namId])
  return (
    <div className="flex pb-2">
      <Dropdown
        tooltip="Năm"
        tooltipOptions={{ position: 'top' }}
        className="mr-2"
        optionLabel="name"
        optionValue="id"
        options={listNam}
        value={namId}
        onChange={(e) => {
          store.dispatch(setNamId(e.value))
        }}
        filter
        filterBy="name"
      />
      <Dropdown
        tooltip="Khoá thi"
        tooltipOptions={{ position: 'top' }}
        className="mr-2"
        optionLabel="date"
        optionValue="id"
        options={listKhoaThi}
        value={khoaThiId}
        onChange={(e) => {
          store.dispatch(setKhoaThiId(e.value))
        }}
        filter
        filterBy="name"
      />
    </div>
  )
}

export default ComboDropdownKhoaThi
